import axiosInstance from "redux/axiosInstance/index";
import {
    LOGIN_SUCCESS,
    LOGIN_FAIL,
    LOAD_USER,
    AUTH_ERROR,
    LOGOUT,
    UPDATE_PROFILE
} from './types'
import setAuthToken from '../../Utils/setAuthToken';
import { NotificationManager } from 'react-notifications';
export const login = (email, password) => async dispatch => {
    const body = JSON.stringify({email, password});
    try {
        const res = await axiosInstance.post(`admin/login`,body);
        dispatch({
            type: LOGIN_SUCCESS,
            payload: res.data
        })
    } catch (error) {
       NotificationManager.error(`${error?.response?.data?.error.message ?? error.message}`,'Error!', 2000);
        dispatch({
            type: LOGIN_FAIL
        })
        
    }
}   

export const loadUser = () => async dispatch => {
    if(localStorage.token){
        setAuthToken(localStorage.token);
    }
    try {
        const res = await axiosInstance.get(`admin/login`);
        dispatch({
            type: LOAD_USER,
            payload: res.data
        });
    } catch (err) {
        dispatch({
            type: AUTH_ERROR
        })
    }
}

export const updateProfile = (id, data) => async dispatch => {
    try {
        const res = await axiosInstance.put(`admin/profile/${id}`, data);
        dispatch({
            type: UPDATE_PROFILE,
            payload: res.data
        });
    } catch (err) {
        dispatch({
            type: AUTH_ERROR
        })
    }
}

export const userLogout = () => dispatch => {
    dispatch({
        type: LOGOUT
    })
    
}
